import React from 'react'
import { withTranslate } from 'react-redux-multilingual'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import InputAdornment from '@material-ui/core/InputAdornment'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'
import { formatMoneyInput, parseToFloat } from '../../helpers/payment'
import PaymentLink from '../../modules/paymentLink'
import StringHelper from '../../helpers/string-helper'

class PaymentBalance extends React.Component {
  state = {
    balance: this.props.initialBalance,
    balanceLimit: this.props.initialBalance
  }

  handleBalanceChange = (event) => {
    const { balanceLimit } = this.state
    const formatted = formatMoneyInput(event.target.value.replace(',', '.'))

    if (formatted === '') {
      this.setState({ balance: '' })
      return
    }

    const numericValue = parseFloat(formatted)
    if (!isNaN(numericValue) && numericValue > balanceLimit) {
      this.setState({ balance: balanceLimit.toFixed(2) })
      return
    }

    this.setState({ balance: formatted })
  }

  handleBalancePayClick = async () => {
    const baseUrl = sessionStorage.getItem('url')
    const property = sessionStorage.getItem('propertyId')
    const booking = sessionStorage.getItem('bookingId')

    const response = await PaymentLink.getPaymentLink(baseUrl, property, booking, this.state.balance)
    const paymentLinkURL = response.status ? response.result.payment_link : null

    if (!StringHelper.isNotEmpty(paymentLinkURL)) return

    const newWindow = window.open('', '_blank')
    try {
      newWindow.location.href = paymentLinkURL
    } catch (err) {
      newWindow.close()
    }
  }

  render() {
    const { translate } = this.props

    return (
      <>
        <Grid item xs={12} style={{ textAlign: 'center', marginTop: 30, marginLeft: 5, marginRight: 5 }}>
          <Typography variant="subtitle2">
            {translate('balanceToPayMessage')}
          </Typography>
        </Grid>

        <Grid item xs={12} style={{ textAlign: 'center', marginTop: 20 }}>
          <Typography variant="subtitle1" style={{ marginBottom: 8 }}>
            {translate('balanceToPayLabel')}
          </Typography>

          <Grid container alignItems="flex-end" justifyContent="center" spacing={2}>
            <Grid item>
              <TextField
                id="cc_payment_amount"
                name="cc_payment_amount"
                value={this.state.balance}
                style={{ width: 180 }}
                onChange={this.handleBalanceChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MonetizationOnIcon />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item>
              <Button variant="contained" onClick={this.handleBalancePayClick}>
                {translate('payLabel')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </>
    )
  }
}

// Retorna o componente só quando há débito (cc_payment_amount finito) e o
// pagamento online está ativo no perfil da propriedade.
function PaymentBalanceGate({ ccPaymentAmount, checkinOnlinePaymentActive, ...props }) {
  if (checkinOnlinePaymentActive !== '1') return null
  const debit = parseToFloat(ccPaymentAmount)
  if (!Number.isFinite(debit)) return null
  return <PaymentBalance {...props} initialBalance={debit} />
}

export default withTranslate(PaymentBalanceGate)
